import { TmApiNotFoundError } from '@/core/error/transport/tmApiNotFoundError'

export class TmApiDealActivityItemNotFoundError extends TmApiNotFoundError {
  public name = 'TmApiDealActivityItemNotFoundError'
}
